import React from 'react';
import CheckOption from './CheckOption';

const FlagText = ({ title, description }) => (
    <span className="flex min-w-0 flex-1 flex-col gap-0.5 break-words">
        <span className="text-sm font-bold text-foreground">{title}</span>
        {description && <span className="text-sm text-foreground/80">{description}</span>}
    </span>
);

/**
 * Read-only on/off and choice settings, with values from a flags object such as `users.circles`.
 * @param {{
 *   flags: { featureFlag: string, display: string, description?: string, type?: 'select',
 *     defaultValue?: string, options?: { value: string, label: string }[] }[],
 *   values?: Object<string, any>,
 * }} props
 */
const ReadOnlyFlagList = ({ flags, values = {} }) => (
    <ul className="flex min-w-0 flex-col gap-5">
        {flags.map((flag) => {
            const value = values[flag.featureFlag] ?? flag.defaultValue;
            return (
                <li key={flag.featureFlag}>
                    {flag.type === 'select' ? (
                        <div className="flex min-w-0 items-center gap-5">
                            <span className="flex h-10 w-40 shrink-0 items-center justify-center rounded-sm border border-primary text-sm font-semibold text-primary">
                                {flag.options?.find((option) => option.value === value)?.label || value || 'Not set'}
                            </span>
                            <FlagText title={`${flag.display}:`} description={flag.description} />
                        </div>
                    ) : (
                        <CheckOption
                            checked={!!values[flag.featureFlag]}
                            label={<FlagText title={flag.display} description={flag.description} />}
                        />
                    )}
                </li>
            );
        })}
    </ul>
);

export default ReadOnlyFlagList;
